// libs
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'o2web-react-core';

// Component
import TitleUnderlined from '../home/parts/banner/TitleUnderlined';

// Styles
import './styles.scss';

// Props and Context
const propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
};
const contextType = {
  t: PropTypes.func,
};

function Header(props, { t }) {
  const {
    title,
    subtitle,
    contentType,
  } = props;

  // temporary lang variable
  // const lang = 'fr';
  return (
    <div className="landing__header">
      <TitleUnderlined title={title}>
        <p className="title-underlined__subtitle">
          <span className="landing__header__subtitle">{subtitle} </span>
          {/* temporary query param */}
          <NavLink
            className="landing__header__link"
            to={`/${t('routes.search')}?filterCategory=${contentType}`}
          >
            {t('pages.landing.orSearch')}
          </NavLink>
        </p>
      </TitleUnderlined>
    </div>
  );
}

Header.propTypes = propTypes;
Header.contextTypes = contextType;

export default Header;



// WEBPACK FOOTER //
// ./src/app/components/pages/landing/Header.js